// extracted by mini-css-extract-plugin
module.exports = {"userInfo":"AvatarDropdown_userInfo__3gMpi","userId":"AvatarDropdown_userId__2mjgi","endShit":"AvatarDropdown_endShit__3mOFx"};